import React from 'react';
import styles from './AgenticPersonas.module.css';

const personas = [
  {
    icon: '👥',
    title: 'Engineering Leader',
    description: 'Empower your team with AI-driven development leadership'
  },
  {
    icon: '👨‍💻',
    title: 'Software Engineer',
    description: 'Enhance your coding capabilities with intelligent assistance'
  },
  {
    icon: '🤖',
    title: 'Data & ML ML Engineer',
    description: 'Leverage AI for advanced data and machine learning solutions'
  },
  {
    icon: '💻',
    title: 'DEvOps and SREs',
    description: 'Streamline operations with secure, reliable infrastructure'
  },
  {
    icon: '🛡️',
    title: 'Security Engineer',
    description: 'Drive product development with AI-powered insights'
  }
];

const AgenticPersonas: React.FC = () => {
  return (
    <section className={styles.section} id="personas">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Agentic AI Personas</h2>
          <p className={styles.subtitle}>
            Tailored AI assistance for every role in your development team
          </p>
        </div>

        <div className={styles.personasGrid}>
          {personas.map((persona, index) => (
            <div key={index} className={styles.personaCard}>
              <div className={styles.iconWrapper}>
                <span className={styles.icon}>{persona.icon}</span>
              </div>
              <h3>{persona.title}</h3>
              <p>{persona.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AgenticPersonas;
